import React from 'react';
import { TableBody as MuiTableBody } from '@mui/material';
import TableRow from './TableRow';
import { TABLE_ROW_TYPES } from './constants';
import { ITableBody } from './interface';

const TableBody = ({ rowsData, columns, onClickRow, styles }: ITableBody) => {
  return (
    <MuiTableBody>
      {rowsData?.map((rowData: any, index: number) => (
        <TableRow
          type={TABLE_ROW_TYPES.BODY}
          onSelect={onClickRow as (a?: number | string) => void | boolean}
          key={`${rowData?.id}_${index}`}
          rowData={rowData}
          columns={columns}
          styles={styles}
        />
      ))}
    </MuiTableBody>
  );
};

export default TableBody;
